import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const articleHeroRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const title = selector('[data-motion-title]')[0]
  const media = selector('[data-motion-media]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse, 'top 92%'),
    delay
  })

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0)
  }

  let mediaAnimation: SharedAnimation
  if (media) {
    mediaAnimation = fadeRevealAnimation(media)
    timeline.add(mediaAnimation.timeline, 0.2)
  }

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()

    titleAnimation?.revert()
    mediaAnimation?.revert()
  }
}
